import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "../../../Containers/ContainerCreate";
import { getChimneyProfileTracksByYear } from "../../../api/getChimneyProfile";
import Spinner from "react-bootstrap/Spinner";

class ChimneyProfileTracksByYearContainer extends React.Component {
  componentDidMount() {
    const { chimDir, year } = this.props;
    this.props.request(chimDir, year);
  }
  componentWillReceiveProps(nextProps) {
    const { chimDir, year: nextYear } = nextProps;
    const { year } = this.props;
    if (nextYear !== year) {
      this.props.request(chimDir, nextYear);
    }
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const tracks = (data && data.data) || [];
    if (loading) {
      return <Spinner animation="border" variant="secondary" />;
    }
    if (!loading && tracks.length === 0) {
      return <div>No tracks posted this year...</div>;
    }
    return render({ tracks, loading, failure });
  };
}

ChimneyProfileTracksByYearContainer.propTypes = {
  chimDir: PropTypes.string.isRequired,
};

export default CreateContainer(getChimneyProfileTracksByYear, ChimneyProfileTracksByYearContainer);
